import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';

import { Global, ThemeProvider } from '@emotion/react';

import { useAuth0 } from '@auth0/auth0-react';

import store from 'features/store';

import RoutesConfig from 'routes';


import en from 'translations/en.json';
import ja from 'translations/ja.json';

import { GlobalStyles } from 'styles/global.styles';
import theme from 'styles/theme';

import { LanguageContext } from 'context/languageContext';
import { AppLocale } from './constant';

interface Translations {
  [key: string]: Translation;
}
interface Translation {
  [key: string]: string;
}

const App = () => {
  const [locale, setLocale] = useState(AppLocale.JP);

  const messages: Translations = {
    en,
    ja
  };

  const { handleRedirectCallback } = useAuth0();

  useEffect(() => {
    const processLoginRedirect = async () => {
      // Check if the URL contains a code and state (indicating the login callback)
      if (
        window.location.search.includes('code=') &&
        window.location.search.includes('state=')
      ) {
        // This processes the callback and stores tokens
        await handleRedirectCallback();
        // Optional: Clean up the URL after processing the callback
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      }
    };

    processLoginRedirect();
  }, [handleRedirectCallback]);

  // Persist the language choice in localStorage
  useEffect(() => {
    const savedLocale = localStorage.getItem('locale') as AppLocale;
    if (savedLocale) {
      setLocale(savedLocale);
    }
  }, []);

  const changeLanguage = (newLocale: AppLocale) => {
    localStorage.setItem('locale', newLocale);
    setLocale(newLocale);
  };

  return (
    <LanguageContext.Provider value={{ locale, changeLanguage }}>
      <IntlProvider locale={locale} messages={messages[locale]}>
        <ThemeProvider theme={theme}>
          <Global styles={GlobalStyles} />
          <Provider store={store}>
            <RoutesConfig />
          </Provider>
        </ThemeProvider>
      </IntlProvider>
    </LanguageContext.Provider>
  );
};

export default App;
